import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Hero from "../components/hero";
import PageFascia from "../components/page-fascia";
import HeroIcons from "../components/hero-icons";
import withPreview from "../utility/with-preview";
import pageUrl from "../utility/page-url";
import HeroCountdown from "../components/hero-countdown";

const PaginaInternaTemplate = ({
  data: { page, menuCorporate },
  pageContext: { langCode },
  location,
}) => {
  const { hero, fasce, headerType } = page;
  return (
    <Layout
      langCode={langCode}
      location={location}
      tags={page.tags}
      headerType={headerType}
    >
      {hero?.value ? (
        hero.value.__typename === "LiferaySiteHeaderHero" ? (
          <Hero data={hero.value} page={page} />
        ) : hero.value.__typename === "LiferaySiteHeaderHeroCountdown" ? (
          <HeroCountdown data={hero.value} menu={menuCorporate} />
        ) : (
          <HeroIcons data={hero.value} page={page} />
        )
      ) : null}
      {fasce
        ? fasce.map((fascia, i) => <PageFascia key={i} data={fascia.value} />)
        : null}
    </Layout>
  );
};

export const Head = ({ data: { meta, page }, pageContext }) => {
  const { pageTitle, htmlTitle } = page;
  const canonical =
    htmlTitle.content?.canonicalUrl?.value ||
    `${meta.siteUrl}/${pageUrl(page)}`;
  return (
    <Seo
      title={htmlTitle.value || pageTitle.value}
      langCode={pageContext.langCode}
      ogImage={htmlTitle.content.ogImage}
      description={htmlTitle?.content?.metaDescription?.value}
      skipEn={pageTitle.content?.skipEn?.value}
      canonical={canonical}
      robots={htmlTitle.content?.metaRobots?.value}
    />
  );
};

export default withPreview(PaginaInternaTemplate, {
  subField: "page",
  fixed: true,
});

export const query = graphql`
  query PaginaInternaQuery($liferayId: Int!, $langCode: String!) {
    meta: gatsbySourceLiferayOptions {
      siteUrl
    }
    page: liferayPaginaInterna(
      liferayFields: {
        liferayId: { eq: $liferayId }
        langCode: { eq: $langCode }
      }
    ) {
      liferayFields {
        siteId
        articleId
        langCode
        tags: taxonomyCategoryBriefs {
          id
          name
        }
      }
      headerType {
        value
      }
      pageTitle {
        value
        content {
          skipEn {
            value
          }
          friendlyUrl {
            value
          }
        }
      }
      htmlTitle {
        value
        content {
          metaDescription {
            value
          }
          canonicalUrl {
            value
          }
        }
        ...PaginainternaTitleFragment
      }
      hero {
        value {
          __typename
          ...SiteHeader_HeroFragment
          ...SiteHeader_Hero_CountdownFragment
          ...SiteHeader_Hero_IconeFragment
        }
      }
      ...BreadcrumbPaginainternaFragment
      ...FasceFragment
    }
    menuCorporate: liferayMenuCorporate(
      liferayFields: { langCode: { eq: $langCode } }
    ) {
      pageTitle {
        value
        content {
          icon {
            value
          }
          description {
            value
          }
          link {
            value
          }
          ctaText {
            value
            content {
              ctaLink {
                value
              }
            }
          }
        }
      }
    }
  }
`;
